module.exports = Promise.all([parcelRequire.load("3arc9"), parcelRequire.load("2xPiU")]).then(() => parcelRequire('lEj5g'));